module.exports = __webpack_public_path__ + "static/media/reset.c67be253.svg";